import React from 'react';
import { Grid, TextField, Typography } from '@mui/material';
import { ChangeHandler } from 'types/form';
import { Specialty } from 'types/specialty';

interface SpecialtyFormProps {
  specialty: Specialty;
  handleChange: ChangeHandler<Specialty>;
  validation: string;
}

const SpecialtyForm: React.FC<SpecialtyFormProps> = ({ specialty, handleChange, validation }) => {
  return (
    <Grid container size={12} spacing={2} maxWidth={900}>
      <Grid size={12}>
        <Typography variant="subtitle2" fontWeight={700} color="primary">
          Dados da especialidade
        </Typography>
      </Grid>

      <Grid size={{ xs: 12, md: 6 }}>
        <TextField
          fullWidth
          autoFocus
          label="Nome"
          placeholder="Digite o nome da especialidade"
          value={specialty.name}
          onChange={e => handleChange('name', e.target.value)}
          error={!!validation}
          helperText={validation}
        />
      </Grid>
    </Grid>
  );
};

export default SpecialtyForm;
